'use client';

import { IconButton } from '@/decodo/components/atoms/IconButton';
import { cn } from '@/lib/utils';
import { useState } from 'react';
import IconCopy from '~/icons/copy-01.svg';
import CheckCircle from '~/svg/IconCheckmarkCircle.svg';

type Props = {
  classNames?: {
    root?: string;
    iconButton?: string;
    copyIcon?: string;
    successIcon?: string;
    container?: string;
  };
  copyText: string;
};

const CopyButton = ({ classNames, copyText }: Props) => {
  const [showingCopiedFeedback, setShowingCopiedFeedback] =
    useState<boolean>(false);

  async function handleCopy() {
    if (showingCopiedFeedback) return;

    setShowingCopiedFeedback(true);

    setTimeout(() => {
      setShowingCopiedFeedback(false);
    }, 2000);

    await navigator.clipboard.writeText(copyText);
  }

  return (
    <div
      data-tracker-component='copy'
      className={cn('dark', classNames?.container)}
    >
      <IconButton
        classNames={{
          root: cn('p-0 w-auto h-auto self-end', classNames?.root),
        }}
        noStyles
        onClick={handleCopy}
      >
        {showingCopiedFeedback ? (
          <CheckCircle
            className={cn('text-brand-500 h-6 w-6', classNames?.successIcon)}
          />
        ) : (
          <IconCopy
            className={cn(
              'text-base-dark-white h-6 w-6 hover:text-gray-500',
              classNames?.copyIcon
            )}
          />
        )}
      </IconButton>
    </div>
  );
};

export default CopyButton;
